import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/button/ButtonToolbar.tsx
var n = (n) => {
	let { className: r = "", alignment: i, children: a, ...o } = n, s = e(r, "btn-toolbar", i === "left" && "justify-content-start", i === "right" && "justify-content-end", i === "center" && "justify-content-center", i === "space-between" && "justify-content-between");
	return /* @__PURE__ */ t("div", {
		...o,
		className: s,
		children: a
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=ButtonToolbar.js.map